import $ from 'jquery';

/**
 * Show or hide loader (spinner).
 */
const showLoader = function () {
	$('#loader').show().fadeTo(250, 0.8);
};

const hideLoader = function () {
	$('#loader').fadeTo(250, 0, function () {
		$(this).hide();
	});
};

export default { showLoader, hideLoader };
